import { makeAutoObservable, runInAction } from 'mobx'
// evertel
import { injectable, inject, decorate } from '@evertel/di'
import { Api } from '@evertel/api'
import { DisplayThread, RoomStore, ThreadStore } from '@evertel/stores'
import { DepartmentAccess, DepartmentsAccessStore } from '@evertel/departments-access'
import { APIDataRoom, APIDataThread } from '@evertel/types'
import { SessionService } from '@evertel/session/SessionService'
import { DrawerController } from '@evertel/message'

const PENDING_INVITE_KEY = 'pendingInviteToken'

export type InviteResult = {
    action: 'ROOM_INVITE' | 'USER_INVITE' | 'DEPARTMENT_INVITE'
    departmentsAccess: DepartmentAccess
    room: APIDataRoom
    thread: APIDataThread
    drawerController: DrawerController
}

class ConsumeInviteController {

    constructor(
        private api: Api,
        private sessionService: SessionService,
        private roomStore: RoomStore,
        private departmentAccessStore: DepartmentsAccessStore,
        private threadStore: ThreadStore,
        private drawerController: DrawerController
    ) {
        makeAutoObservable(this)
    }

    get pendingInviteToken () {
        return this.sessionService.pendingInviteToken
    }

    setPendingInviteToken(token: any) {
        this.sessionService.setPendingInviteToken(token)
    }

    consumePendingInvite = async (skipNavigation = false) => {
        if (!this.pendingInviteToken) return

        const token = this.pendingInviteToken

        // clear stored token
        this.sessionService.setPendingInviteToken(null)

        return this.consumeInvite(token)
    }

    consumeInvite = async (token: string) => {
        if (!token) return

        // TODO: GC-2135 retest on newer react version, this call happens early and seems to fail because
        // the network stack isn't ready yet.  Happes in iOS 18.7.1
        await new Promise(resolve => setTimeout(resolve, 1000))
        const response = await this.api.Routes.Invite.postConsumeById(token) as unknown as InviteResult

        switch (response?.action) {
            case 'ROOM_INVITE':
                this.roomStore.update(response.room)
                this.sessionService.addRoomIdIBelongTo(response.room.id as number)
                this.departmentAccessStore.update(response.departmentsAccess)
                break
            case 'USER_INVITE':
                this.threadStore.update(response.thread as DisplayThread)
                break
            case 'DEPARTMENT_INVITE':
                if (!response.departmentsAccess) return
                if (response.departmentsAccess.departmentId) {
                    this.sessionService.setSelectedDeparmentId(response.departmentsAccess.departmentId)
                }
                //after new department is added, new rooms are added
                this.drawerController.fetchActiveRooms()
                this.departmentAccessStore.update(response.departmentsAccess)
                break
            default:
                break
        }

        return response
    }
}

let i = 0
decorate(injectable(), ConsumeInviteController)
decorate(inject(Api), ConsumeInviteController, i++)
decorate(inject(SessionService), ConsumeInviteController, i++)
decorate(inject(RoomStore), ConsumeInviteController, i++)
decorate(inject(DepartmentsAccessStore), ConsumeInviteController, i++)
decorate(inject(ThreadStore), ConsumeInviteController, i++)
decorate(inject(DrawerController), ConsumeInviteController, i++)

export { ConsumeInviteController }
